import { useDisablePushNotificationsMutation, useEnablePushNotificationsMutation } from './api'

export const useMobilePushNotifications = () => {
    const [enablePushNotifications] = useEnablePushNotificationsMutation()
    const [disablePushNotifications] = useDisablePushNotificationsMutation()

    return { enablePushNotifications, disablePushNotifications }
}
